import type {PageRouteConfig} from '@router';

import CustomDealApplyDiscount from 'modules/Services/PromotionCenter/CustomDeal/ApplyDiscount/ApplyDiscount';

export function createPromotionCenterCustomDealApplyDiscountRoute(): PageRouteConfig {
  return {
    element: <CustomDealApplyDiscount />,
    layout: {
      title: 'انتخاب کالاها و درصد تخفیف',
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
